const React = require('react');
const ArrowBackIcon = require('@material-ui/icons/ArrowBack').default;
const {
  Link,
} = require('../../../../router');
const {
  LINK_ADMIN_ACCOUNTS_KYC,
} = require('../../../../constants/links');
const LayoutA = require('../../../dumb/Layout/A');
const CaptionA = require('../../../dumb/Caption/A');
const HeaderA = require('../../../dumb/Header/A');
const ButtonD = require('../../../dumb/Button/D');
const Profile = require('./Profile');
const DownloadIcon = require("../../../icons/Download");


module.exports = (props) => {
  const params = props.params || {};
  const {
    id,
  } = params;

  return (
    <LayoutA>
      <HeaderA>
        <CaptionA>Account KYC</CaptionA>
        <ButtonD
          component={Link}
          href={LINK_ADMIN_ACCOUNTS_KYC}
        >
          <ArrowBackIcon/>
          <div className="pl15">Back</div>
        </ButtonD>
      </HeaderA>
      <Profile
        id={id}
        disabledSettings
      />
    </LayoutA>
  );
};
